
import { defineComponent } from "vue";
import api, { CompanyList, Company, RequestPaging, PageBounding, RequestSort }  from "../../api/backend-api";
import { AxiosError } from "axios";

interface State {
  msg: string;
  backendResponse: CompanyList;
  requestFilter: Company;
  requestPaging: RequestPaging;
  requestSorting: RequestSort;
  pageBounds: PageBounding[];
  errors: AxiosError[];
}

export default defineComponent({
  name: "ReceiverCompany",
  mounted() {
    this.$nextTick(() => {
      this.getList();
    });
  },

  data: (): State => {
    const company_list = { } as CompanyList;
    const company_struct = { } as Company;
    const paging_struct = { Limit: 10, Skip: 0 } as RequestPaging;
    const sort_struct = { Pattern: '-id' } as RequestSort;

  return {
      msg: "Receiver Company",
      backendResponse: company_list,
      requestFilter: company_struct,
      requestPaging: paging_struct,
      requestSorting: sort_struct,
      pageBounds: [],
      errors: [],
    };
  },
  methods: {
    // Fetches posts when the component is created.
    getList() {
      this.backendResponse = { } as CompanyList;
      const request_params = api.createRequestParams(this.requestFilter, this.requestPaging, this.requestSorting)
      api
        .getReceiverCompanyList(request_params)
        .then((response) => {
          this.backendResponse = response.data;
        })
        .catch((error: AxiosError) => {
          this.errors.push(error);
        });
    },
  },
});
